import { getDataReaderClient } from "@multiweb/clients/util";
import { ISectionLoggerFactory, LoggingSection } from "@multiweb/logging";
import { DIContainer } from "Global/Base/DIContainer";
import { OWObject } from "OW.Remoting/Remoting/DataTypes/OWObject";
import { Event } from "../../../../../Global/Base/Events";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../../Global/Base/Rights/RightTypes";
import { IValidatable, IValidationResult } from "../../../../UI.BaseControls/ControlInterfaces";
import { EditableControl } from "../../../../UI.BaseControls/EditableControl";
import { registerCustomElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { TextLOVEdit as BaseTextLovEdit } from "../../Controls/TextLOVEdit";

export class TextLOVEdit extends EditableControl {
    //#region Fields
    public override readonly validityChanged = new Event<IValidatable, IValidationResult>();

    private _textlovedit: BaseTextLovEdit;
    //#endregion Fields

    //#region Properties
    public set actualObject(v: OWObject) {
        this._textlovedit.actualObject = v;
    }

    public get actualObject(): OWObject {
        return this._textlovedit.actualObject;
    }

    public get textLovEdit(): BaseTextLovEdit {
        return this._textlovedit;
    }

    public override set value(value: string) {
        this._textlovedit.controlValue = value;
    }

    public override get value(): string {
        return this._textlovedit.controlValue;
    }

    public override set enabled(value: boolean) {
        this.textLovEdit.enabled = value;
        if (!value)
            this.setAttribute("Enabled", value.toString());
        else
            this.removeAttribute("Enabled");
    }
    //#endregion Properties

    //#region Constructors
    protected override _constructor(): void {
        super._constructor();

        this._innerElement = document.createElement("div");
        this.appendChild(this._innerElement);
        this.classList.add("TextLOVEdit");
    }
    //#endregion Constructors

    //#region Methods
    public setInnerAttribute(attrName: string, val: string): void {
        if (val == undefined)
            return;

        this.setAttribute(attrName, val);
        this._innerElement.setAttribute(attrName, val);
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        this._innerElement.setAttribute(attrName, newVal);
    }

    /**
     * Vytvoří TextLOVEdit
     */
    public renderLov(): void {
        this._textlovedit = new BaseTextLovEdit({
            element: this._innerElement,
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
            dataReaderClient: getDataReaderClient(),
            logger: DIContainer.instance.create(ISectionLoggerFactory).create(LoggingSection.textLOVEdit),
        });
        this._textlovedit.validityChanged.add((_el, validity) =>
            this.validityChanged.trigger(this, validity));
        this._textlovedit.isEditing = true;

        this._textlovedit.valueChanged.add((_s, _e) => {
            this.callEvent("change");
        });
    }

    /**
     * Předá focus na TextLOVEdit
     */
    public override focus(): void {
        this._textlovedit.focus();
    }
    //#endregion Methods
}

registerCustomElement("tsc-textlovedit", TextLOVEdit);
